var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromotion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 113,
    viewBox: "0 0 127 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M.06 51.886a29.474 29.474 0 0 1 22.105-28.441V7.677a7.37 7.37 0 0 1 3.168-6.042 7.368 7.368 0 0 1 6.705-.884L96.36 24.108l28.513-1.695a7.363 7.363 0 0 1 5.526 1.99 7.348 7.348 0 0 1 1.698 2.453c.393.925.593 1.92.586 2.926v51.577a7.362 7.362 0 0 1-2.505 5.526 7.356 7.356 0 0 1-5.747 1.769l-9.652-1.179-6.925 39.346a7.372 7.372 0 0 1-7.368 6.116H73.74a7.361 7.361 0 0 1-5.675-2.557 7.368 7.368 0 0 1-1.693-5.99l5.452-32.42-40.302 11.494a6.205 6.205 0 0 1-1.99 0 7.367 7.367 0 0 1-7.367-7.368V80.328A29.472 29.472 0 0 1 .06 51.886zm117.888-14.294-14.736.81v32.79l14.736 1.841V37.592zM82.434 118.2H94.37l5.747-32.567-3.757-.442-8.842 2.431-5.084 30.578zM36.901 86.37l40.155-11.126a7.368 7.368 0 0 1 4.052-1.253l7.368-2.063V37.15L36.9 18.435V86.37zM22.165 64.265V39.213a14.736 14.736 0 0 0 0 25.347v-.295z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotion);
export default __webpack_public_path__ + "static/media/promotion.b9d0fd17b8ccf1a85e59a74304e03930.svg";
export { ForwardRef as ReactComponent };